<template>
  <v-row>
    <v-col>
      <v-row class="px-3">
        <v-col
            cols="12"
            sm="10"
            md="5"
            lg="4">
          <v-text-field
              v-model="params.pattern"
              v-test="{ input: 'pattern' }"
              clearable
              :label="$t('Поиск по наименованию организации')"
              hide-details
              @keydown.native.enter="focusOnBtn('searchBtn')" />
        </v-col>
        <v-col
            class="text-left pr-2"
            align-self="center">
          <btn-icon-tip
              id="search"
              ref="searchBtn"
              icon="search"
              icon-color="primary"
              :tip="$t('Поиск')"
              @click="search" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <paginated-data-table
              v-if="getOrganizationRegistrationRequests"
              ref="paginatedTable"
              :headers="headers"
              :items="requests"
              :loading="isLoading"
              item-key="organizationId"
              :total-count="totalCount"
              :items-per-page="itemsPerPage"
              :request-method="getOrganizationRegistrationRequests">
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.organizationShortName="{ item }">
              {{ item.organizationShortName }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.inn="{ item }">
              {{ item.inn }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.ogrn="{ item }">
              {{ item.ogrn }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.participantType="{ item }">
              {{ $t(PARTICIPANT_TYPE_ENUM[item.participantType]) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.phone="{ item }">
              {{ item.phone }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestDate="{ item }">
              {{ item.requestDate
                ? $moment(item.requestDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.organizationType="{ item }">
              {{ $t(ORGANIZATION_TYPE_ENUM[item.organizationType]) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.organizationId="{ item }">
              <!-- <route-btn-tip
                  v-if="(isAdmin) &&
                    item.status === ORG_REQUEST_STATUSES.INPROCESS"
                  :id="item.organizationId"
                  :tip="$t('Обработка заявки')"
                  icon="settings"
                  :to="{ path: `${urlRootPath}/organizationRequestProcess/${item.organizationId}` }" /> -->
              <route-btn-tip
                  :id="item.organizationId"
                  :tip="$t('Просмотр заявки')"
                  icon="visibility"
                  :to="{ path: `${urlRootPath}/organizationRequestProcess/${item.organizationId}` }" />
            </template>
          </paginated-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import RouteBtnTip from '@/components/reused/ui/RouteBtnTip.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import { PARTICIPANT_TYPES, ORG_REQUEST_STATUSES } from '@/constants/business'
  import { PARTICIPANT_TYPE_ENUM, ORGANIZATION_TYPE_ENUM } from '@/constants/enums'
  import { mapActions, mapState } from 'vuex'
  import { ORGANIZATION_REQUESTS } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      RouteBtnTip,
      PaginatedDataTable
    },
    props: {
      status: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        PARTICIPANT_TYPE_ENUM,
        ORGANIZATION_TYPE_ENUM,
        PARTICIPANT_TYPES,
        ORG_REQUEST_STATUSES,
        isLoading: false,
        itemsPerPage: 10,
        params: {
          pattern: '',
          status: this.status
        }
      }
    },
    computed: {
      ...mapState(ORGANIZATION_REQUESTS.NAMESPACE, {
        requestsInfo: state => status => (state[ORGANIZATION_REQUESTS.STATE.REQUESTS][status] || {})
      }),
      headers () {
        const headers = [
          { text: this.$t('Организация'), align: 'start', sortable: false, value: 'organizationShortName' },
          { text: this.$t('ИНН'), align: 'start', sortable: true, value: 'inn' },
          { text: this.$t('ОГРН'), align: 'start', sortable: true, value: 'ogrn' },
          { text: this.$t('Категория участия'), align: 'start', sortable: false, value: 'participantType' },
          { text: this.$t('Телефон'), align: 'start', sortable: false, value: 'phone' },
          { text: this.$t('Дата подачи запроса'), align: 'start', sortable: false, value: 'requestDate' },
          { text: this.$t('Форма организации'), align: 'start', sortable: false, value: 'organizationType' },
          { text: this.$t('Действия'), align: 'start', sortable: false, value: 'organizationId' }
        ]

        return headers
      },
      totalCount () {
        return this.requestsInfo(this.status).totalCount || 0
      },
      requests () {
        return this.requestsInfo(this.status).items || []
      }
    },
    watch: {
      status: {
        immediate: true,
        handler (newStatus, oldStatus) {
          if (newStatus !== oldStatus) {
            this.params.status = newStatus
          }
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(ORGANIZATION_REQUESTS.NAMESPACE, {
        getOrganizationRegistrationRequestsAction: ORGANIZATION_REQUESTS.ACTIONS.GET_ORGANIZATION_REGISTRATION_REQUESTS,
        clearOrganizationRegistrationRequestsAction: ORGANIZATION_REQUESTS.ACTIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUESTS
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearOrganizationRegistrationRequestsAction(this.status)
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getOrganizationRegistrationRequests: async function (params) {
        try {
          this.isLoading = true
          await this.getOrganizationRegistrationRequestsAction({
            ...params,
            ...this.params
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
